import EmployeeWorkInLeaveBenefitComponents from "../components/EmployeeWorkInLeaveBenefit";
import useEmployeeWorkInLeaveBenefit from "../hooks/useEmployeeWorkInLeaveBenefit";

function EmployeeWorkInLeaveBenefit() {
  const employeeWorkInLeaveBenefitProps = useEmployeeWorkInLeaveBenefit();
  return (
    <EmployeeWorkInLeaveBenefitComponents
      {...employeeWorkInLeaveBenefitProps}
    />
  );
}

export default EmployeeWorkInLeaveBenefit;
